import { ActionType, createAction } from 'typesafe-actions';

export const initializeTrackingAction = createAction(
  'INITIALIZE_TRACKING',
  (isTrial: boolean) => isTrial
)<boolean>();

export type TrackingActions = ActionType<typeof initializeTrackingAction>;
